<template>
    <div
        class="ai-data-field-row-skeleton flex items-center gap-3 rounded-lg border border-ui-lines bg-main-bg px-3 py-2.5"
        aria-hidden="true"
    >
        <div class="min-w-0 flex-1 space-y-1.5">
            <div class="flex items-center gap-2">
                <VcSkeletonLoader
                    type="row"
                    width="18%"
                    height="12px"
                    row-height="12px"
                />
                <VcSkeletonLoader
                    type="row"
                    width="15%"
                    height="12px"
                    row-height="12px"
                />
            </div>
            <VcSkeletonLoader
                type="row"
                width="25%"
                height="10px"
                row-height="10px"
            />
        </div>

        <VcSkeletonLoader
            type="square"
            class="shrink-0"
            width="16px"
            height="16px"
            row-height="16px"
        />
    </div>
</template>

<script setup lang="ts">
import { VcSkeletonLoader } from '@voicenter-team/voicenter-ui-plus'
</script>